// Transactions.cshtml: the card's activity, newest as the API returns it.
import { money, shortDate } from '@qor/web-shared';
import { isCredit } from '../account';
import { CardPage } from '../components/CardPage';
import { usePageTitle } from '../components/CustomerLayout';

const MINUS = '−';

export function TransactionsPage() {
  usePageTitle('Transactions');
  return (
    <CardPage feature="Transactions" withTransactions>
      {({ transactions, refresh, refreshing }) => (
        <>
          <div className="qcw-greeting-row">
            <div>
              <h1 className="qcw-greeting">Transactions</h1>
              <p className="qcw-subgreeting">Your full activity history.</p>
            </div>
            <button type="button" className="qcw-refresh" onClick={() => void refresh()} disabled={refreshing}>
              Refresh
            </button>
          </div>

          <section className="qcw-section" aria-label="Transaction history">
            {transactions.length === 0 ? (
              <p className="qcw-empty">No activity yet. New transactions will show up here.</p>
            ) : (
              transactions.map((tx, i) => {
                const credit = isCredit(tx.transactionType);
                const sign = credit ? '+' : MINUS;
                return (
                  <div className="qcw-transaction-row" key={tx.providerTransactionReference ?? `row-${i}`}>
                    <span
                      className={`qcw-transaction-icon ${credit ? 'qcw-icon-credit' : 'qcw-icon-debit'}`}
                      aria-hidden="true"
                    >
                      {sign}
                    </span>
                    <div className="qcw-transaction-body">
                      <div className="qcw-transaction-desc">{tx.description}</div>
                      <div className="qcw-transaction-meta">{shortDate(tx.postedAt) ?? 'Pending'}</div>
                    </div>
                    <div className={`qcw-transaction-amount ${credit ? 'qcw-amount-credit' : ''}`}>
                      {sign}
                      {money(Math.abs(tx.amount), tx.currency)}
                    </div>
                  </div>
                );
              })
            )}
          </section>
        </>
      )}
    </CardPage>
  );
}
